import { AlternativeData } from "@/types/alternative";
import styles from "./css/CompareElectricity.module.css";
import { ElectricityContent } from "./ElectricityContent";
import { Project } from "@/types";
import { GreenLightningIcon } from "@/icons/GreenLightningIcon";
import { toatal_sqm } from "@/utils/alternative";
import { useTranslation } from "react-i18next";

interface CompareElectricityProps {
    alternatives: Set<AlternativeData>;
    project: Project;
    bestAlternative: AlternativeData;
}

export const CompareElectricity = ({alternatives, project, bestAlternative}: CompareElectricityProps) => {
    const { t } = useTranslation('CompareElectricity');
    return (
        <div className={styles.container}>
            {Array.from(alternatives).map((alternative) => (
                <div key={alternative.id} className={styles.alternativeWrapper}>
                    <div className={styles.alternativeHeader}>
                        <div className={styles.headerTitle}>
                            <h1>{alternative.name}</h1>
                            {bestAlternative.id === alternative.id && <GreenLightningIcon size="16" tooltip={t('preferredAlternativeTooltip')}/>}
                        </div>
                        <div className={styles.headerInfo}>
                            <p>{t('totalSqm', { total: toatal_sqm(alternative) })}</p>
                            <p>{t('residentialUnitsPrefix') + alternative.residental_unit_area_planned}</p>
                        </div>
                    </div>
                    <div className={styles.content}>
                        <ElectricityContent alternative={alternative} project={project} />
                    </div>
                </div>
            ))}
        </div>
    )
}